<template>
  <main class="bind-page">
    <section class="stage">
      <div style="width: 2rem; height: 2rem; margin: .4rem auto 0; position: relative;">
        <img class="top-scan" src="./static/images/bind-device/top-scan.png" alt="" style="width: 100%; height: 100%; display: block;">
        <div style="text-align:center;position:absolute;width:1.3rem;height:1.3rem;left:.35rem;top:.35rem;font-size:0;padding-top:.11rem;">
          <span class="scan-label" style="margin-top: .2rem">扫描绑定设备</span>
          <img src="./static/images/bind-device/qrcode.png" style="width:.74rem;height:.74rem;margin:0 auto;display:block;" alt="扫码绑定设备二维码">
          <span class="scan-code">设备号：000000</span>
        </div>
      </div>

      <p class="hero-tip">请输入设备背面的设备号或扫描二维码</p>

      <div class="input-row">
        <span class="input-display">{{ iccid || "请输入设备号" }}</span>
        <input v-model="iccid" class="input-overlay" placeholder="请输入设备号">
        <button type="button" aria-label="扫码输入" v-if="wxReady" @click="handleScan">
          <img src="./static/images/bind-device/input-scan.png" alt="">
        </button>
      </div>

      <template v-if="cardCheckOK && needAuth === 1 && !binded">
        <div class="input-row">
          <input v-model="ruleForm.mobile" placeholder="输入手机号">
          <button type="button" @click="handleSms">{{ smsBtnTxt }}</button>
        </div>
        <div class="input-row">
          <input v-model="ruleForm.code" placeholder="输入验证码">
        </div>
      </template>

      <button class="bind-btn" type="button" v-if="!cardCheckOK" @click="handleCheckCard">查询</button>
      <button class="bind-btn" type="button" v-else-if="!binded" @click="handleBindCard">立即绑定</button>
      <button class="bind-btn" type="button" v-else @click="handleQueryCard">确认</button>

      <section class="tips">
        <h2>温馨提示：</h2>
        <p>
          1-卡号为卡芯后的数字，短号为设备背面的字母和数字<br>
          2-因产品实名使用之后，无法二次销售，故无法退卡<br>
          3-绑卡时请核实该地区是否能使用，谨慎操作<br>
          4-新疆，西藏，云南，港澳台不可使用!
        </p>
      </section>
    </section>
  </main>
</template>

<script>
import wx from "weixin-js-sdk"

export default {
  name: "bindNew",
  data () {
    return {
      iccid: "",
      cardLengthCheck: false,
      cardCheckOK: false,
      wxReady: false,
      sms: false,
      binded: false,
      needAuth: 0,
      cardlist: [],
      smsBtnTxt: "发送验证码",
      ruleForm: { iccid: "", mobile: "", name: "", code: "" }
    }
  },
  watch: {
    iccid (iccid) {
      this.iccid = (iccid || "").toUpperCase()
      this.cardCheckOK = false
      this.needAuth = 0
      this.binded = false
      if (this.iccid.indexOf("C") !== -1) {
        this.cardLengthCheck = this.iccid.length === 20 || (this.iccid.length >= 6 && this.iccid.length <= 10)
      } else {
        this.cardLengthCheck = this.iccid.length === 19 || (this.iccid.length >= 6 && this.iccid.length <= 10)
      }
    }
  },
  methods: {
    handleCheckCard () {
      this.cardCheckOK = false
      this.binded = false
      this.$toast.loading("查询中")
      localStorage.setItem("iccid", this.iccid)
      this.fetchData("/card/queryCard", { iccid: this.iccid }, (res) => {
        this.$toast.clear()
        if (res.code) {
          this.cardCheckOK = true
          this.needAuth = res.data.needAuth
          if (this.needAuth === 0) {
            this.$router.push({ name: "index" })
          } else if (res.data.mobile) {
            this.handleQueryCard()
          }
        } else if (res.url) {
          window.location.href = res.url
        } else {
          this.$notify(res.msg)
        }
      })
    },
    handleQueryCard () {
      this.$router.push({ name: "index", query: { iccid: this.iccid } })
    },
    handleBindCard () {
      this.$toast.loading("绑定中")
      this.ruleForm.iccid = this.iccid
      this.fetchDataPost("/card/bind", this.ruleForm, (res) => {
        this.$toast.clear()
        if (res.code) {
          this.$toast.success(res.msg)
          this.$router.push({ name: "index" })
        } else {
          this.$toast.fail(res.msg)
        }
      })
    },
    initWechatJs () {
      const url = encodeURIComponent(location.href.split("#")[0])
      this.fetchData("/wechat/jssdk", { url }, (res) => {
        if (res.code) {
          wx.config(res.data)
          wx.ready(() => {
            this.wxReady = true
          })
        }
      })
    },
    handleScan () {
      if (!this.wxReady){
        this.$toast.fail("扫码控件加载失败，请手动输入号码")
      }
      wx.scanQRCode({
        needResult: 1,
        scanType: ["barCode"],
        success: (res) => {
          this.iccid = res.resultStr.includes(",") ? res.resultStr.split(",")[1] : res.resultStr
        },
        fail:(res)=>{
          this.$toast.fail("启动摄像头失败"+JSON.stringify(res))
        }
      })
    },
    getCardListByOpenid () {
      this.fetchData("/card/querylist", {}, (res) => {
        if (res.code) {
          for (const card of res.data) {
            this.cardlist.push({ name: card.iccid, value: card.iccid })
            if (card.default === 1) this.iccid = card.iccid
          }
          if (!this.iccid && res.data && res.data[0]) this.iccid = res.data[0].iccid
        }
      })
    },
    handleSms () {
      if (this.sms) return
      this.sms = true
      this.$toast.loading()
      this.fetchData("/sms/send", { mobile: this.ruleForm.mobile }, (res) => {
        this.$toast.clear()
        if (!res.code) {
          this.sms = false
          this.$toast.fail("发送失败")
          return
        }
        this.$toast.success("发送成功")
        let s = 60
        const intval = setInterval(() => {
          this.smsBtnTxt = `${s}秒重发`
          if (s <= 0) {
            this.smsBtnTxt = "发送验证码"
            this.sms = false
            clearInterval(intval)
          }
          s -= 1
        }, 1000)
      })
    }
  },
  created () {
    this.initWechatJs()
    if (this.$route.query.cardno) {
      this.iccid = this.$route.query.cardno
    } else if (!this.$route.query.nostorage) {
      this.iccid = localStorage.getItem("iccid") || ""
    }
    if (this.iccid) {
      if (this.$route.query.auto) this.handleCheckCard()
    } else if (!this.$route.query.nostorage) {
      const openid = sessionStorage.getItem("token")
      if (!openid && this.$route.query.appid) {
        this.$router.push({ name: "login", query: { appid: this.$route.query.appid, path: "/" } })
      } else if (openid) {
        this.getCardListByOpenid(openid)
      }
    }
  }
}
</script>

<style scoped src="./static/css/bind-device.css"></style>
<style scoped>
.input-display {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 2.5rem;
}

.input-overlay {
  position: absolute;
  left: 0.24rem;
  right: 0.64rem;
  top: 0;
  bottom: 0;
  width: auto;
  border: none;
  background: transparent;
  color: #111;
  font-size: 0.18rem;
  line-height: 0.252rem;
  font-weight: 500;
  padding: 0;
}

.input-overlay:focus {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/newpage/bind.vue